{
  "toast": {
    "aBTestStarted": "A/B test started",
    "draftCampaignCreated": "Draft campaign créé",
    "campaignScheduled": "Campaign scheduled",
    "journeyCreated": "Journey créé",
    "journeyFlowSaved": "Journey flow enregistré",
    "segmentSaved": "Segment enregistré",
    "templateSaved": "Template enregistré",
    "reportExported": "{{reportType}} exporté",
    "draftCreated": "Brouillon créé : {{name}}",
    "abWinner": "Gagnant : variante {{variant}}"
  },
  "errors": {
    "failedToLoadABTests": "Échec du chargement de a/B tests",
    "failedToCreateABTest": "Échec de la création de a/B test",
    "failedToPickWinner": "Échec : pick winner",
    "enterACampaignName": "Saisissez a campaign name",
    "selectAnAudienceSegment": "Sélectionnez un audience segment",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToLoadSegments": "Échec du chargement de segments",
    "failedToLoadTemplates": "Échec du chargement de templates",
    "failedToCreateCampaign": "Échec de la création de campaign",
    "actionFailed": "Échec de action",
    "failedToLoadPerformance": "Échec du chargement de performance",
    "attributionFailed": "Échec de attribution",
    "failedToLoadJourneys": "Échec du chargement de journeys",
    "failedToCreateJourney": "Échec de la création de journey",
    "failedToSaveJourneyFlow": "Échec de l'enregistrement de journey flow",
    "failedToLoadLifecyclePresets": "Échec du chargement de lifecycle presets",
    "exportFailed": "Échec de l'export",
    "failedToCreateSegment": "Échec de la création de segment",
    "previewFailed": "Échec de preview",
    "templateNameIsRequired": "Template name is requis",
    "failedToCreateTemplate": "Échec de la création de template"
  },
  "pages": {
    "noCampaignSelected": "No campaign sélectionnered",
    "selectACampaignFromTheList": "Sélectionnez un campaign from the list to view delivery and engagement metrics.",
    "noAttributionData": "No attribution data",
    "scheduleCampaign": "Schedule campaign",
    "campaigns": "Campaigns",
    "noCampaignsYet": "No campaigns yet",
    "createApproveScheduleAndLaunchMulti": "Create, approve, schedule, et launch multi-channel campaigns avec tracked delivery.",
    "createADraftWithAnAudience": "Create a draft avec an audience segment et template, then submit pour approbation.",
    "marketing": "Marketing",
    "engagement": "Engagement",
    "openRate": "Open rate",
    "conversions": "Conversions",
    "engagementFunnel": "Engagement funnel",
    "campaignPerformanceEngagementAndConversionsFor": "Campaign performance, engagement, et conversions pour votre marketing scope",
    "espWebhooks": "ESP webhooks",
    "sendgridMailgunAndSimilarProvidersPost": "SendGrid, Mailgun, et similar providers POST open/click events à update campaign metrics",
    "journeys": "Journeys",
    "noJourneys": "No journeys",
    "automateNurtureFlowsWithTriggersActions": "Automate nurture flows avec triggers, actions, delays, et goals using a visual step builder.",
    "createAJourneyToAutomateFollow": "Create a journey à automate follow-ups after key events.",
    "lifecycle": "Lifecycle",
    "oneClickDraftsForWelcomeCart": "One-click drafts pour welcome, cart recovery, win-back, upsell, et renewal programs.",
    "reports": "Rapports",
    "exportCampaignAndJourneyDataAnd": "Export campaign et journey data, et inspect multi-touch attribution per campaign.",
    "audienceSegments": "Audience segments",
    "noSegmentsYet": "No segments yet",
    "dynamicSegmentsWithRuleBuilderAnd": "Dynamic segments avec rule builder et live preview",
    "createYourFirstDynamicAudienceSegment": "Create votre first dynamic audience segment.",
    "templates": "Templates",
    "noTemplates": "No templates",
    "reusableEmailContentWithVersioningVia": "Reusable email content avec versioning via le shared template service.",
    "createATemplateToAttachTo": "Create a template à attach à email campaigns."
  },
  "labels": {
    "variantARef": "Variant A ref",
    "variantBRef": "Variant B ref",
    "sent": "Sent",
    "opens": "Opens",
    "clicks": "Clicks",
    "bounces": "Bounces",
    "unsubscribes": "Unsubscribes",
    "conversions": "Conversions",
    "openRate": "Open rate",
    "clickRate": "Click rate",
    "roi": "ROI",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "removeStep": "Remove step",
    "stepType": "Step type",
    "action": "Action",
    "waitAmount": "Wait amount",
    "unit": "Unit",
    "displayLabel": "Display label",
    "sendAt": "Send at",
    "matchMode": "Match mode",
    "field": "Field",
    "operator": "Operator",
    "value": "Value",
    "name": "Nom",
    "channel": "Channel",
    "audience": "Audience",
    "template": "Template",
    "springPromo": "Spring promo",
    "selectSegment": "Select segment",
    "optional": "Optional",
    "trigger": "Trigger",
    "welcomeSeries": "Welcome series",
    "audienceOptional": "Audience (optional)",
    "useDefaultRules": "Use default rules",
    "campaign": "Campaign",
    "model": "Model",
    "selectCampaign": "Select campaign",
    "allModels": "All models",
    "segmentName": "Segment name",
    "templateName": "Template name",
    "subjectLine": "Subject line",
    "bodyHtmlOrPlainText": "Body (HTML ou plain text)"
  },
  "formActions": {
    "createDraft": "Créer un brouillon"
  },
  "listActions": {
    "newCampaign": "Nouvelle campagne"
  }
}
